import { BaseComponent } from '../../types';

interface CardProps extends BaseComponent {
  title?: string;
  content?: string;
  style?: React.CSSProperties;
}

export function Card({ className, title, content, style }: CardProps) {
  return (
    <div
      className={`flex flex-col items-start lg:w-[320px] w-[165px] lg:h-auto h-[178px] lg:p-6 p-4 lg:gap-4 gap-3 transition-all duration-300 cursor-pointer ${className || ''}`}
      style={{
        borderRadius: '16px',
        border: '1px solid rgba(59, 130, 246, 0.20)',
        background: 'rgba(15, 23, 42, 0.60)',
        boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.40)',
        backdropFilter: 'blur(10px)',
        position: 'absolute',
        ...style,
      }}
      onMouseEnter={e => {
        e.currentTarget.style.border = '1px solid rgba(59, 130, 246, 0.20)';
        e.currentTarget.style.background = 'rgba(15, 23, 42, 0.60)';
        e.currentTarget.style.boxShadow = '0 4px 80px 0 #3BBCE4';
        e.currentTarget.style.backdropFilter = 'blur(10px)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.border = '1px solid rgba(59, 130, 246, 0.20)';
        e.currentTarget.style.background = 'rgba(15, 23, 42, 0.60)';
        e.currentTarget.style.boxShadow = '0 4px 24px 0 rgba(0, 0, 0, 0.40)';
        e.currentTarget.style.backdropFilter = 'blur(10px)';
      }}
    >
      <img
        src="/icons/fetature.svg"
        alt="Feature icon"
        width="72"
        height="72"
        className="lg:block hidden"
      />
      <img
        src="/icons/fetature.svg"
        alt="Feature icon"
        width="36"
        height="36"
        className="lg:hidden block"
      />

      <div className="text-left">
        <h3 className="text-white font-semibold mb-2 lg:text-base text-sm">
          {title}
        </h3>
        <p
          className="lg:text-sm text-xs"
          style={{
            color: 'rgba(148, 163, 184, 0.80)',
            fontFamily: 'Inter',
            fontSize: window.innerWidth >= 1024 ? '13px' : '11px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: window.innerWidth >= 1024 ? '21px' : '16px',
          }}
        >
          {content}
        </p>
      </div>
    </div>
  );
}
